import { from } from "rxjs";
import { switchMap, take } from "rxjs/operators";
import { selectFreeRecipeResourceBuildingId } from "../../../selectors/selectRecipeInfo";
import { utilBuildings } from "../../../utils/utilBuildings";
import { utilProduction } from "../../../utils/utilProduction";
import { actionModalCloseAll } from "../../modals/actionModal";
import { actionBuildingsSelect } from "../../player-base/buildings/actionBuildings";
export var createPathSelectBuilding = function (getBuilding) { return function (action, state$, deps) {
    return deps.inStoreDependencies.viewportChanged$.pipe(take(1), switchMap(function (viewport) {
        var state = state$.value;
        var building = getBuilding(action, state$, deps);
        var origin = utilBuildings.getCenterPositionOnScreen(building, viewport);
        var actions = [
            actionModalCloseAll(),
            actionBuildingsSelect(building, origin, true),
        ];
        if (action.taskType && action.taskType.resourceId) {
            var recipeId = selectFreeRecipeResourceBuildingId(state, action.taskType.resourceId, building);
            utilProduction.setProductionRecipe(recipeId, building.balancing.id);
        }
        return from(actions);
    }));
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/path/createPathSelectBuilding.ts
// module id = 2370
// module chunks = 3